import { render, staticRenderFns } from "./PetPackAddRemoveButton.vue?vue&type=template&id=585b2b29"
import script from "./PetPackAddRemoveButton.vue?vue&type=script&lang=js"
export * from "./PetPackAddRemoveButton.vue?vue&type=script&lang=js"
import style0 from "./PetPackAddRemoveButton.vue?vue&type=style&index=0&id=585b2b29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports